import { Options } from './models';

export const defaultOptions: Options<any> = {
  verticalSeparator: true,
	highlightRowOnHover: true,
  elevation: 5,
  isExpanded: true,
};
